export default __webpack_public_path__ + "static/media/man3.f6236814.jpg";